var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlecheDroit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "21px",
    viewBox: "0 0 13 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fleche droit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R\\xE9servation-FRONT-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Serveat-r\\xE9servation-05-bis",
    transform: "translate(-945.000000, -539.000000)",
    fill: "#262957",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inscription",
    transform: "translate(120.000000, 371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "addition-login"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fermeture",
    transform: "translate(610.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heure",
    transform: "translate(50.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.514627,49.3392789 C164.774964,48.5189303 164.840372,47.2542907 165.660721,46.5146274 C166.48107,45.774964 167.745709,45.8403724 168.485373,46.6607211 L177.467513,56.6226675 L168.440491,65.9948606 C167.67423,66.7904218 166.408123,66.8141741 165.612561,66.0479129 C164.817,65.2816517 164.793248,64.0155445 165.559509,63.2199834 L172.000523,56.5326809 L165.514627,49.3392789 Z",
    id: "fleche-droit"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheDroit);
export default __webpack_public_path__ + "static/media/fleche-droit.1b0e05bd9fa251a08300f127ca02b16f.svg";
export { ForwardRef as ReactComponent };